import { render } from "./ProductRow.vue?vue&type=template&id=e8c1a9e0&scoped=true&ts=true"
import script from "./ProductRow.vue?vue&type=script&lang=ts"
export * from "./ProductRow.vue?vue&type=script&lang=ts"

import "./ProductRow.vue?vue&type=style&index=0&id=e8c1a9e0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c1a9e0"]])

export default __exports__